export default class Buck {
    constructor(name, images, age, classification, points, published, notes, privateNotes) {
        this.name = name;
        this.images = images
        this.age = age;
        this.classification = classification;
        this.points = points;
        this.published = published;
        this.notes = notes;
        this.privateNotes = privateNotes;
    };
}